import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Lock, ArrowRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: "var(--blush)" }}
    >
      <div
        className="w-full max-w-sm"
        style={{
          backgroundColor: "var(--white)",
          borderRadius: "20px",
          padding: "2.5rem 2rem",
          boxShadow: "0 4px 24px rgba(44,44,42,0.06)",
        }}
      >
        <div className="flex items-center justify-center mb-6">
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 14,
              backgroundColor: "var(--coral-light)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Lock size={22} color="var(--coral)" />
          </div>
        </div>

        <h1
          data-testid="admin-login-heading"
          className="text-center mb-1"
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.5rem",
            fontWeight: 600,
            color: "var(--charcoal)",
          }}
        >
          Admin
        </h1>
        <p
          className="text-center mb-6"
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: "0.875rem",
            color: "var(--charcoal-light)",
          }}
        >
          Sign in to view waitlist data
        </p>

        <form data-testid="admin-login-form" onSubmit={handleSubmit} className="flex flex-col gap-3">
          <Input
            data-testid="admin-email-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="h-11 rounded-xl"
            style={{
              fontFamily: "var(--font-sans)",
              backgroundColor: "var(--blush)",
              border: "1px solid rgba(44,44,42,0.08)",
            }}
          />
          <Input
            data-testid="admin-password-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="h-11 rounded-xl"
            style={{
              fontFamily: "var(--font-sans)",
              backgroundColor: "var(--blush)",
              border: "1px solid rgba(44,44,42,0.08)",
            }}
          />

          {error && (
            <p
              data-testid="admin-login-error"
              style={{
                fontFamily: "var(--font-sans)",
                fontSize: "0.8rem",
                color: "#c53030",
                textAlign: "center",
              }}
            >
              {error}
            </p>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="btn-coral flex items-center justify-center gap-2 w-full mt-2"
            style={{
              padding: "12px",
              fontSize: "0.9rem",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Signing in..." : "Sign in"}
            {!loading && <ArrowRight size={16} />}
          </button>
        </form>

        <a
          href="/"
          data-testid="admin-back-link"
          className="block text-center mt-5"
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: "0.8rem",
            color: "var(--charcoal-light)",
            textDecoration: "none",
          }}
        >
          &larr; Back to Depth Co.
        </a>
      </div>
    </div>
  );
}
